import { YANDEX_METRIKA_ID } from "@/utils/constans";

export function sendMetrik(event, goal) {
	if (window.ym) {
		window.ym(YANDEX_METRIKA_ID, event, goal);
	} else {
		console.warn("Яндекс.Метрика не загружена.");
	}
}

export function initYandexMetrika() {
	// console.log("initYandexMetrika()");

	if (typeof window === "undefined") return;
	if (!YANDEX_METRIKA_ID) {
		console.warn("YANDEX_METRIKA_ID is missing");
		return;
	}

	if (window.ym) {
		console.log("Yandex Metrika already initialized");
		return;
	}

	// 🔹 Заглушка до загрузки
	window.ym = function () {
		(window.ym.a = window.ym.a || []).push(arguments);
	};
	window.ym.l = 1 * new Date();

	const script = document.createElement("script");
	script.src = "https://mc.yandex.ru/metrika/tag.js";
	script.async = true;
	script.onload = () => {
		console.log("Yandex Metrika loaded ✅");
		window.ym(YANDEX_METRIKA_ID, "init", {
			clickmap: true,
			trackLinks: true,
			accurateTrackBounce: true,
			webvisor: true,
			ecommerce: "dataLayer"
		});
	};
	document.head.appendChild(script);
}

export function trackPixel(pixelId) {
	if (typeof __GetI === "undefined") {
		window.__GetI = [];
	}
	(function () {
		const p = {
			type: pixelId === "registration" ? "CONVERSION" : "VIEW",
			site_id: "10109", // 10109
			order: [],
			transaction_id: "",
			revenue: "",
			pixel_id: pixelId,
		};
		window.__GetI.push(p);
		const domain = typeof window.__GetI_domain === "undefined" ? "px.adhigh.net" : window.__GetI_domain;
		const src = (document.location.protocol === "https:" ? "https://" : "http://") + domain + "/t.js";
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.src = src;
		const s = document.getElementsByTagName("script")[0];
		s.parentNode.insertBefore(script, s);
	})();
	console.log("trackPixel() pixelId:", pixelId);
}


export function adsHeadsCheck() {
	let img = document.createElement("img");
	img.src = `https://ads-heads.ru/c/rl.gif?label=RLlflHBO&ttl={TTL}&rid=289052093`;
	img.width = 1;
	img.height = 1;
	img.style.display = "none";
	document.body.appendChild(img);
}
export function adsHeadsRegistration() {
	let img = document.createElement("img");
	let TTL = new Date().getTime();
	img.src = `https://ads-heads.ru/c/rl.gif?label=RL52NL0z&ttl={TTL}&rid=68477918`;
	img.width = 1;
	img.height = 1;
	img.style.display = "none";
	document.body.appendChild(img);
}

export function ar_callCounter(sz) {
	window.adrCounterStorage = window.adrCounterStorage || [];

	window.adrCounterStorage.push(function () {

		new window.AdriverCounterJS({ sid: SID, bt: 62, sz: sz }, { id: "", gid1: "", yid1: "" });
		console.log('callCounter:', sz);
	});
};
